import * as React from 'react';

import cn from 'classnames';

import { getFormattedFileSize } from '@utils';

import {
	IBrandDownloadPanelProps,
	IBrandDownloadPanelState,
} from './types';

import * as s from './BrandDownloadPanel.scss';

export class BrandDownloadPanel extends React.Component<IBrandDownloadPanelProps, IBrandDownloadPanelState> {

	state: IBrandDownloadPanelState = {
		isButtonActive: false,
	};

	activateButton() {
		this.setState(
			{
				isButtonActive: true,
			},
			() => window.setTimeout(this.inactivateButton, 300),
		);
	}

	inactivateButton = () => {
		this.setState({
			isButtonActive: false,
		});
	};

	onClick = () => {
		const {
			onClick,
		} = this.props;
		const {
			isButtonActive,
		} = this.state;

		if (!isButtonActive) {
			this.activateButton();

			if (onClick) {
				onClick();
			}
		}
	};

	render() {
		const {
			linkUrl,
			title,
			fileSize,
			classNames: {
				block: blockClassName,
				button: buttonClassName,
				buttonActive: buttonActiveClassName,
				fileSize: fileSizeClassName,
			} = {},
		} = this.props;
		const {
			isButtonActive,
		} = this.state;

		return (
			<div className={cn(s.block, blockClassName)}>
				<a
					href={linkUrl}
					className={cn(s.button, buttonClassName, {
						[s.active]: isButtonActive,
						[buttonActiveClassName]: isButtonActive,
					})}
					download
					onClick={this.onClick}
				>
					{title}
				</a>

				{fileSize > 0 &&
					<div className={cn(s.fileSize, fileSizeClassName)}>
						{getFormattedFileSize(fileSize, 1)}
					</div>
				}
			</div>
		);
	}

}
